





















































import { Component, Mixins, Prop } from 'vue-property-decorator';
import LocationPanelNavItem from '@/components/location/location-panel/LocationPanelNavItem.vue';
import LocationPanelMarkerItem from '@/components/location/location-panel/location-panel-item/LocationPanelMarkerItem.vue';
import LocationPanelStudyItem from '@/components/location/location-panel/location-panel-item/LocationPanelStudyItem.vue';
import LocationModel from '@/location/Location';
import CategoriesWithMarkers from '@/mixins/CategoriesWithMarkers';

@Component({
    components: { LocationPanelNavItem, LocationPanelMarkerItem, LocationPanelStudyItem },
})
export default class LocationPanelNav extends Mixins(CategoriesWithMarkers) {
    @Prop({ type: LocationModel, required: true })
    location!: LocationModel;
}
